import i18next from 'i18next';
import { PAGE_TYPE } from '../../../features/base/app/constants';
import { addMessage, setIsChatRead, updateMessage } from '../../../features/base/chat/action';
import { getAccessToken, getLocalID } from '../../../features/base/local';
import { setAudioMuted, setVideoMuted } from '../../../features/base/media';
import { addLocalMember, addMember, addMembers, checkRoleLevel, getLocalIDMember, getLocalMember, getLocalMemberRole, getMemberByUserID, getUserIDByMemberId, MEMBER_STATUS, PERMISSION, removeMember, requestPresentation, responsePresentation, ROLE, setBridgeId, setHandlerMember, setMemberChatDisabled, setMemberNick, setMemberPinned, setMemberRecord, setMemberRole, setSpeakerId } from '../../../features/base/members';
import { saveNotification, showNotification } from '../../../features/base/notification/actions';
import { getPropertyValue, updateGridOption, updateRoomPolicy, updateSettings } from '../../../features/base/settings';
import { isChatOpend, isHandlerOpend, setLiveEnquiries, toggleHandlerEnquries } from '../../../features/base/sidebar';
import { convertVodList } from '../../../features/base/vod/functions';
import { deleteCanvasIndex, deleteCanvaskey, setCanvasPoint } from '../../../features/canvas/actions';
import { connectionDual } from '../../../features/dualConference/action';
import { getRoomOption, setRoomPermissions } from '../../../features/room';
import { showStartAttendance } from '../../../features/room-attendance/actions';
import { getStartScreenShare, setShareScreenUserId, stopScreen } from '../../../features/screen-share';
import { addDocumentList, addShareItem, getDocumentItemByUUID, removeShareItem, setFocusShareItem, updateShareItem } from '../../../features/share-layout';
import { DEFAULT_INDEX, DOCUMENT_MODE, VOD_MODE } from '../../../features/share-layout/constants';
import { toggleLoad } from '../../../features/base/loading';
import { onRefetchTestList, onTestSubmitted } from '../../../features/test/action';
import { getCurrentMode, setLayoutMode, videoLayoutMode, VIDEO_MODE_LIST } from '../../../features/video-layout';
import { createTaskQueue } from '../../util/helpers';
import PeerConnection from '../PeerConnection';
import { command } from './command';
const isRemote = true;
const taskQueue = createTaskQueue();
class MateMessage {
    constructor() {
        this.initialEntrySetting = this.initialEntrySetting.bind(this);
    }
    async handleMessage(data) {
        switch (data.class) {
            case 'Event.Room.Member.Call.Offer': {
                const from_member_id = data.payload.from;
                const from_user_id = getUserIDByMemberId(APP.store.getState, from_member_id);
                if (!Array.isArray(APP.peerconnections)) {
                    APP.peerconnections = [];
                }
                // ★재연결(re-offer) 순서 수정: 상대가 듀얼모니터 페이지 이동(다음→이전) 후 재요청하면
                // 같은 상대(user_id)에 대한 offer 가 다시 온다. 기존엔 새 answer-peer 의 initLocalStream 을
                // "먼저" 시작한 뒤 옛 peer 를 닫아, 둘이 공유하는 jitsi 로컬 비디오 트랙/ICE/시그널링이 충돌해
                // 재요청 시 영상이 안 붙는(카메라 blank) 문제가 있었다. → 기존 answer-peer 를 "먼저" 정리한 뒤
                // 새 peer 를 만들어 초기화한다.
                const existingPeer = APP.peerconnections.find(p => p && p.user_id === from_user_id);
                try {
                    existingPeer && (await existingPeer.disconnect());
                }
                catch (error) {
                    console.log(error);
                }
                const peer = new PeerConnection(from_user_id, from_member_id, true);
                const { userSelectedCameraDeviceId } = APP.store.getState()['features/base/settings'];
                peer.initLocalStream(userSelectedCameraDeviceId, data.payload.offer);
                APP.peerconnections.push(peer);
                break;
            }
            case 'Event.Room.Member.Call.Answer':
                APP.eventManager.publish('CALL_ANSWER', data.payload);
                break;
            case 'Event.Room.Member.Call.IceCandidate':
                APP.eventManager.publish('CALL_CANDIDATE', data.payload);
                APP.peerconnections.forEach(peer => {
                    if (peer.checkMember(data.payload.from)) {
                        peer.addIceCandidate(data.payload.ice_candidate);
                    }
                });
                break;
            case 'Meeting.Meeting.Closed':
            case 'Room.Member.Leave':
                APP.management.leave();
                self.close();
                APP.eventManager.publish('UPDATE_PAGE', {
                    page: PAGE_TYPE.ERROR,
                });
                break;
            case `Event.${command['set-nickname']}`:
                this.handlerChangeNick(data.payload);
                break;
            case `Event.Room.Notification.Receive`:
                try {
                    let recevieMessage = JSON.parse(data.payload.message)?.message;
                    APP.store.dispatch(saveNotification(recevieMessage, isRemote));
                }
                catch (error) { }
                break;
            // set bridge session
            case `Event.${command['set-jitsi-id']}`:
                this.handlerSetBridgeSession(data.payload);
                break;
            // 문서 상태 변경
            case 'Meeting.Document.StatusChanged':
                this.handlerDocumentStatus(data.payload);
                break;
            // 사용자 입장
            case `Event.${command['join-room']}ed`:
                taskQueue.enqueue(async (onFinish) => {
                    await this.handlerJoined(data.payload.message, data.payload.group_id);
                    onFinish();
                });
                break;
            // 사용자 퇴장 Event.Room.Member.Left
            case `Event.${command['left-member-room']}`:
                taskQueue.enqueue(async (onFinish) => {
                    await this.handlerLefted(data.payload.user_id, data.payload.group_id);
                    onFinish();
                });
                break;
        }
        switch (data.class) {
            case `Event.${command['member-kick']}ed`:
                this.handlerKickMember(data.payload);
                break;
            // 레이아웃 모드 변경 (grid, pin, voice, screen)
            case `Event.${command[videoLayoutMode.screen]}`:
                this.handlerScreenOption(data.payload);
                break;
            case `Event.${command[videoLayoutMode.grid]}`:
                this.handlerUpdateLayoutMode(videoLayoutMode.grid);
                break;
            case `Event.${command[videoLayoutMode.seminar]}`:
                this.handlerUpdateLayoutMode(videoLayoutMode.seminar);
                break;
            case `Event.${command[videoLayoutMode.pin]}`:
                this.handlerUpdateLayoutMode(videoLayoutMode.pin);
                break;
            case `Event.${command[videoLayoutMode.voice]}`:
                this.handlerUpdateLayoutMode(videoLayoutMode.voice);
                break;
            // 화면 가시성 레이아웃 모드 변경 ( screen, document, note, white, vad )
            case `Event.${command['set-layout-visiblity']}`:
                this.handlerUpdateViewVisible(data.payload);
                break;
            /**
             * share (document)
             */
            // 문서 focus
            case `Event.${command['set-vod-file']}`:
                break;
            case `Event.${command['del-vod-file']}`:
                break;
            case `Event.${command['set-document']}`:
                this.handlerUpdateDocument(data.payload);
                break;
            case `Event.${command['del-document']}`:
                this.handlerDelDocument(data.payload);
                break;
            case `Event.${command[videoLayoutMode.white]}`:
                this.handlerFocusItem(videoLayoutMode.white, data.payload);
                break;
            case `Event.${command[videoLayoutMode.document]}`:
                this.handlerFocusItem(videoLayoutMode.document, data.payload);
                break;
            case `Event.${command['set-canvas']}`:
                this.handlerSetShareCanvas(data.payload);
                break;
            case `Event.${command['del-canvas']}`:
                this.handlerDelShareCanvas(data.payload);
                break;
            case `Event.${command['focus-vod-item']}`:
                this.handlerFocusItem(videoLayoutMode.vod, data.payload);
                break;
            /**
             * 채팅
             */
            case `Event.${command['send-text']}`:
            case `Event.${command['send-private-text']}`:
                this.handlerSetMessage(data.payload);
                break;
            case `Event.${command['send-file']}`:
                this.handlerSetFile(data.payload);
                break;
            /**
             * Member
             */
            // 녹화 - recording
            case `Event.${command['set-member-record']}`:
                this.handlerRecording(data.payload);
                break;
            case `Event.${command[`set-audio-false`]}`:
            case `Event.${command[`set-all-audio-false`]}`:
                this.handlerUpdateAudio(false);
                break;
            case `Event.${command[`set-audio-true`]}`:
            case `Event.${command[`set-all-audio-true`]}`:
                this.handlerUpdateAudio(true);
                break;
            case `Event.${command[`set-video-false`]}`:
            case `Event.${command[`set-all-video-false`]}`:
                this.handlerUpdateVideo(false);
                break;
            case `Event.${command[`set-video-true`]}`:
            case `Event.${command[`set-all-video-true`]}`:
                this.handlerUpdateVideo(true);
                break;
            case `Event.${command['set-role']}`:
                this.handlerUpdateRole(data.payload.message, data.payload.group_id);
                break;
            /**
             * 발표자 요청
             */
            case `Event.${command['request-presentation']}`:
                this.handlerRequestPresentation(data.payload);
                break;
            case `Event.${command['response-presentation']}`:
                this.handlerResponsePresentation(data.payload);
                break;
            case `Event.${command['member-add-pin']}ed`:
                this.handlerUpdatePin(data.payload, true);
                break;
            case `Event.${command['member-del-pin']}d`:
                this.handlerUpdatePin(data.payload, false);
                break;
            case `Event.${command['set-handler-up']}`:
                this.handlerRaiseHand(data.payload, true);
                break;
            case `Event.${command['set-handler-down']}`:
                this.handlerRaiseHand(data.payload, false);
                break;
            /**
             * 사용자 채팅 사용/해제
             */
            case `Event.${command['member-chat-disable']}d`:
                this.handlerChatDisabled(data.payload, true);
                break;
            case `Event.${command['member-chat-enable']}d`:
                this.handlerChatDisabled(data.payload, false);
                break;
            /**
             * survey 설문좃사
             */
            case `Event.${command['share-survey']}`:
                this.notifySurvey(data.payload);
                break;
            case `Event.${command['reply-survey']}`:
                this.replySurvey(data.payload);
                break;
            /**
             * policy
             */
            case `Event.Room.Grid.Count.Set`:
                this.setGridOption(data.payload);
                break;
            case `Event.${command['set-policy']}d`:
                this.updatePolicy(data.payload);
                break;
            case 'Meeting.Meeting.Signaled':
                this.handlerMimac(data.payload);
                break;
        }
    }
    async handlerMimac(data) {
        const { class: classes } = data.payload;
        switch (classes) {
            case 'MIMAC.Conference.Finished':
                APP.management.leave('강의가 종료되었습니다.');
                break;
            case 'MIMAC.Test.Started':
            case 'MIMAC.Test.Finished':
                // 시작/종료는 모든 참가자의 목록/화면 전환에 필요 — 전체 재조회 유지.
                // 단 백그라운드 갱신이므로 전체화면 로딩은 띄우지 않는다(showLoad 기본 false).
                APP.store.dispatch(onRefetchTestList());
                // ★유지 필수: 교사의 '테스트/설문조사 시작' 버튼(TestItem)이 toggleLoad(true)만
                // 걸고 해제를 이 수신 경로에 의존한다 — 제거하면 시작 교사 화면에 로딩 영구 고착.
                APP.store.dispatch(toggleLoad(false));
                break;
            case 'MIMAC.Test.Submitted':
                // 누군가의 제출 — 과거엔 전원 무필터 전체 재조회(REST 폭풍 + 전원 로딩 캐스케이드).
                // 역할별 최소 처리(교사=제출현황 부분갱신, 학생=본인 제출만 재조회)로 축소.
                APP.store.dispatch(onTestSubmitted(data.payload));
                break;
            case 'MIMAC.Enquiry.Queue.Accepted':
                APP.store.dispatch(setLiveEnquiries(data.payload.member_id));
                APP.eventManager.publish('UPDATE_LIVE_ENQUIRY', data.payload);
                break;
            case 'MIMAC.Enquiry.Quit':
                if (data.payload.enquiry_id === getRoomOption(APP.store.getState).uuid) {
                    const is_host = data.payload.is_host;
                    if (is_host) {
                        await APP.management.leave('1:1 라이브가 종료되었습니다');
                    }
                    else
                        APP.store.dispatch(setLiveEnquiries());
                }
                APP.eventManager.publish('UPDATE_LIVE_ENQUIRY', data.payload);
                break;
            case 'MIMAC.Enquiry.Queue.Changed':
                if (checkRoleLevel(getLocalMemberRole(APP.store.getState), ROLE.PRESENTER)) {
                    const openSide = isHandlerOpend(APP.store.getState);
                    if (!openSide) {
                        APP.store.dispatch(toggleHandlerEnquries());
                    }
                }
                APP.eventManager.publish('UPDATE_LIVE_ENQUIRY', data.payload);
                break;
            case 'Enquiry.MembersChanged':
                APP.eventManager.publish('UPDATE_LIVE_ENQUIRY', data.payload);
                break;
        }
    }
    // 회의실 입장 초기 세팅
    initialEntrySetting(data) {
        return new Promise(async (resolve, reject) => {
            const { dispatch, getState } = APP.store;
            const user_uuid = getLocalID(getState);
            if (!user_uuid)
                return reject('인증에 실패했습니다.');
            const { member_uuid, layout, view_visible, role, permissions, pinned, members, document_list, video_list, hide_member_info, speaker_id, auto_set_document, last_notification, chat_disabled, } = data;
            /**
             * Policy
             */
            const individualLive = hide_member_info && !auto_set_document;
            dispatch(updateSettings({ individualLive }));
            dispatch(setSpeakerId(speaker_id));
            if (individualLive && checkRoleLevel(role, ROLE.MANAGER)) {
                await APP.API.readyMeeting();
            }
            // 로컬 사용자 입장
            await dispatch(
            // @ts-ignore
            addLocalMember({
                user_uuid,
                member_uuid,
                role,
                permissions,
                hidden: false,
                pinned,
                chat_disabled,
            }));
            // members 배열의 각 멤버 객체에 isLocal 속성 추가
            const response = await fetch(`/api/meeting/v1/members?meeting_id=${getRoomOption(getState).uuid}&offset=0&limit=${members.length}`)
                .then(res => res.json())
                .then(res => {
                return res.result.items;
            });
            const updatedMembers = members.map(async (member) => {
                const item = response.find(i => i.user_uuid === member.user_uuid);
                if (item) {
                    await dispatch(addMember({
                        ...member,
                        nickname: item?.nickname || '',
                    }));
                }
                else {
                    await dispatch(addMember({
                        ...member,
                        nickname: member.nickname || '',
                    }));
                }
            });
            // addMembers 함수 호출
            await dispatch(addMembers(updatedMembers, member_uuid));
            dispatch(setRoomPermissions(permissions));
            if (last_notification) {
                const { message, group_id: last_group } = JSON.parse(last_notification);
                if (last_group === '') {
                    dispatch(saveNotification(message, isRemote));
                }
                else {
                    dispatch(showNotification({
                        titleKey: 'notify.notifyMessage',
                        description: message,
                    }));
                }
            }
            let list = [];
            if (APP.config.name === 'class') {
                const response = await APP.API.getKlassDocument();
                if (response.complete) {
                    response.data &&
                        response.data.map(item => {
                            if (document_list.find(dItem => dItem.uuid === item.uuid))
                                return;
                            const data = {
                                uuid: item.uuid,
                                user_uuid,
                                file: {
                                    name: item.filename,
                                },
                                isWhiteBoard: false,
                                shared: true,
                                page: item.resource_id,
                                list: item.completed_pages,
                                count: item.completed_pages.length,
                                complete: true,
                                config: DOCUMENT_MODE,
                            };
                            dispatch(addShareItem(data, false));
                        });
                }
            }
            /**
             * (SCREEN MODE) 화면 공유
             */
            const screen_track_id = data.screen_shared_jitsi_id;
            if (screen_track_id) {
                const screen_member_id = data.screen_shared_member_uuid;
                const screen_user_id = getMemberByUserID(getState, screen_member_id);
                dispatch(setShareScreenUserId(screen_track_id, screen_user_id || screen_member_id, isRemote));
            }
            /**
             * video-layout
             */
            // 레이아웃 저장
            const mode = getCurrentMode(getState, { mode: layout, viewVisible: view_visible });
            dispatch(setLayoutMode(mode, isRemote));
            dispatch(updateSettings({ hide_member_info }));
            /**
             * Share
             */
            const isSharedPermission = permissions.includes(PERMISSION.SHARE);
            const values = Object.entries(video_list).reduce((acc, [v, itemList]) => acc.concat(itemList), []);
            const vod_list = await convertVodList(values, document_list);
            const filteredVodConfigs = vod_list.filter(itemA => {
                return document_list.some(itemB => itemB.uuid === itemA.uuid);
            });
            const otherConfigs = document_list.filter(itemA => itemA.config !== VOD_MODE);
            // Document list 저장
            dispatch(addDocumentList([...list, ...vod_list, ...filteredVodConfigs, ...otherConfigs], member_uuid, isSharedPermission));
            // 함수 사용
            getMeetingIceServer()
                .then(iceServerData => {
                // ICE 서버 데이터로 무언가를 수행
                dispatch(updateSettings({ iceServer: iceServerData }));
            })
                .catch(error => {
                // 에러 처리
                APP.UI.alertMessage('듀얼모니터 서버 설정에 실패했습니다.');
            });
            // share document
            if (APP.config.option.workbook) {
                if (data.document_focus_item) {
                    const { uuid, index } = data.document_focus_item;
                    const focusUId = uuid === '' ? data.whiteboard_focus_item.uuid : uuid;
                    const focusIndex = uuid === '' ? data.whiteboard_focus_item.index : index;
                    dispatch(setFocusShareItem(focusUId, focusIndex, videoLayoutMode.document, isRemote));
                }
            }
            else {
                if (data.document_focus_item) {
                    const { uuid, index } = data.document_focus_item;
                    dispatch(setFocusShareItem(uuid, index, videoLayoutMode.document, isRemote));
                }
                if (data.whiteboard_focus_item) {
                    const { uuid, index } = data.whiteboard_focus_item;
                    dispatch(setFocusShareItem(uuid, index, videoLayoutMode.white, isRemote));
                }
            }
            if (data.vod_shared_video_uuid) {
                dispatch(setFocusShareItem(data.vod_shared_video_uuid, DEFAULT_INDEX, videoLayoutMode.vod, isRemote));
            }
            dispatch(updateRoomPolicy(individualLive ? { ...data.policy, pin_option: 'auto' } : data.policy, checkRoleLevel(role, ROLE.MANAGER) ? false : true));
            return resolve(true);
        });
    }
    /**
     * 사용자 입장
     */
    async handlerJoined(message) {
        try {
            if (message.type !== 'hidden') {
                APP.eventManager.publish('UPDATE_LIVE_ENQUIRY');
                const { dispatch } = APP.store;
                const remote = {
                    ...message,
                    local: false,
                    status: MEMBER_STATUS.OCCUPIDE,
                    existed: false,
                };
                await dispatch(addMember(remote));
            }
        }
        catch (error) {
            APP.UI.alertMessage('error');
        }
    }
    async handlerLefted(user_id) {
        try {
            const { getState, dispatch } = APP.store;
            const member = getMemberByUserID(getState, user_id);
            if (member && !member?.local) {
                await APP.store.dispatch(removeMember(member));
            }
        }
        catch (error) {
            APP.UI.alertMessage('error');
        }
    }
    handlerSetBridgeSession({ message }) {
        // from -> member_uuid
        const bridge_sessions = message.bridge_sessions;
        const user_uuid = message.user_id;
        if (bridge_sessions && bridge_sessions.length > 0)
            APP.store.dispatch(setBridgeId(user_uuid, bridge_sessions[0]));
    }
    /**
     * (MEMBER) 사용자 녹화 알림.
     * @param {object} data
     */
    handlerRecording(data) {
        const { getState, dispatch } = APP.store;
        const { to, recording } = data;
        const user_uuid = getUserIDByMemberId(getState, to);
        if (user_uuid) {
            dispatch(setMemberRecord(user_uuid, recording, isRemote));
        }
    }
    /**
     * (LAYOUT)
     * 레이아웃 모드 변경
     * @param {string} mode
     */
    handlerUpdateLayoutMode(mode) {
        APP.store.dispatch(setLayoutMode(mode, isRemote));
    }
    /**
     * (LAYOUT)
     * 화면 가시성으로 레이아웃 모드 변경
     * @param {object} {view_visible}
     */
    handlerUpdateViewVisible({ view_visible }) {
        let mode = null;
        Object.keys(view_visible).map(v => {
            if (view_visible[v])
                mode = v;
        });
        if (!mode) {
            const currentMode = getCurrentMode(APP.store.getState);
            if (VIDEO_MODE_LIST.includes(currentMode))
                mode = currentMode;
            else
                mode = videoLayoutMode.default;
        }
        mode && this.handlerUpdateLayoutMode(mode);
    }
    /**
     * (TRACK)
     * 사용자 오디오 ON / OFF
     * @param {Boolean} muted
     */
    handlerUpdateAudio(muted) {
        APP.store.dispatch(setAudioMuted(muted));
    }
    /**
     * (TRACK)
     * 사용자 비디오 ON / OFF
     * @param {Boolean} muted
     */
    handlerUpdateVideo(muted) {
        APP.store.dispatch(setVideoMuted(muted));
    }
    /**
     * (MEMBER)
     * 사용자 권한 업데이트
     * @param {object} data
     */
    handlerUpdateRole(data, group_id) {
        const { target, role, permissions } = data;
        APP.store.dispatch(setMemberRole(target, role, isRemote, group_id !== '' ? true : false));
        if (target === getLocalID(APP.store.getState)) {
            // 회의실 내 권한 세팅
            APP.store.dispatch(setRoomPermissions(permissions));
        }
    }
    /**
     * (MEMBER)  발표자 권한 요청
     * @param {object} data
     * @returns
     */
    handlerRequestPresentation(data) {
        const { from } = data;
        APP.store.dispatch(requestPresentation(false, from));
    }
    /**
     * (MEMBER) 사용자 발표 응담
     * @param {object} data
     */
    handlerResponsePresentation(data) {
        const { to, accepted } = data;
        const user_uuid = getUserIDByMemberId(APP.store.getState, to);
        APP.store.dispatch(responsePresentation(user_uuid, accepted, isRemote));
    }
    /**
     * (MEMBER) 사용자 PIN 변경
     * @param {object} data
     * @param {Boolean} pinned
     */
    handlerUpdatePin(data, pinned) {
        APP.store.dispatch(setMemberPinned(data.message.target, pinned, isRemote));
    }
    /**
     * (MEMBER) 사용자 채팅 사용/해제
     * @param {object} data
     * @param {Boolean} disabled
     */
    handlerChatDisabled(data, disabled) {
        APP.store.dispatch(setMemberChatDisabled(data.message.target, disabled, isRemote));
    }
    /**
     * (MEMBER) 사용자 강제 퇴장
     * @param {object} data
     */
    async handlerKickMember(data) {
        const { getState, dispatch } = APP.store;
        const { to, from, type } = data;
        if (type === 'close') {
            await APP.management.leave();
        }
        else {
            const toUserId = getUserIDByMemberId(getState, to);
            const fromUserId = getUserIDByMemberId(getState, from);
            const localID = getLocalID(getState);
            if (localID === toUserId) {
                if (fromUserId !== toUserId) {
                    const fromMember = getMemberByUserID(getState, fromUserId);
                    const displayName = fromMember?.nickname;
                    const individualLive = getPropertyValue(getState, 'individualLive');
                    const text = i18next.t(individualLive ? 'notify.closeLive' : 'notify.kickMember', { displayName });
                    await APP.management.leave(text);
                }
                else {
                    await APP.management.leave(i18next.t('notify.dupLogin'), true);
                }
            }
        }
    }
    /**
     * (MEMBER) 사용자 닉네임 수정
     * @param {*} data
     */
    handlerChangeNick(data) {
        const user_id = getUserIDByMemberId(APP.store.getState, data.from);
        if (user_id) {
            APP.store.dispatch(setMemberNick(user_id, data.message.nickname, isRemote));
        }
    }
    /**
     * (MEMBER) 손들기
     * @param {object} data
     * @param {Boolean} handler
     */
    handlerRaiseHand(data, handler) {
        const { getState, dispatch } = APP.store;
        const { to, message } = data;
        const user_uuid = getUserIDByMemberId(getState, to);
        user_uuid && dispatch(setHandlerMember(user_uuid, handler, message?.at, isRemote));
        // 손들기 상태 변경시 사이드바 열기 (수정 요청으로 인한 주석처리 2025-07-04)
        // if (checkRoleLevel(getLocalMemberRole(APP.store.getState), ROLE.PRESENTER)) {
        // 	const openSide = isHandlerOpend(APP.store.getState);
        // 	if (!openSide) {
        // 		APP.store.dispatch(toggleHandlerEnquries());
        // 	}
        // }
    }
    /**
     * (SCREEN SHARE)
     * 화면 공유 옵션 업데이트
     * @param {object} data
     */
    handlerScreenOption(data) {
        const { target, jitsi_id } = data;
        const changeJitsi = !jitsi_id || jitsi_id === '' ? null : jitsi_id;
        const changeTarge = !target || target === '' ? null : target;
        if (!changeJitsi && getStartScreenShare(APP.store.getState)) {
            APP.store.dispatch(stopScreen());
            return;
        }
        APP.store.dispatch(setShareScreenUserId(changeJitsi, changeTarge, isRemote));
    }
    /**
     * 문서
     */
    /**
     * 현재 문서 공유시 공유 업데이트
     */
    handlerUpdateDocument(data) {
        const { dispatch, getState } = APP.store;
        const { document } = data;
        const user_uuid = getMemberByUserID(getState, document.member_uuid);
        const localId = getLocalIDMember(getState);
        if (document.shared || user_uuid === localId) {
            dispatch(updateShareItem(document.uuid, {
                ...document,
                user_uuid,
            }, isRemote));
        }
    }
    /**
     * 문서 삭제
     * @param {*} data
     */
    handlerDelDocument(data) {
        APP.store.dispatch(removeShareItem(data.uuid, isRemote));
    }
    /**
     * 문서 변환 완료 시 상태 변경
     * @param {object} {data}
     */
    handlerDocumentStatus(data) {
        const { uuid, resource_id, status: documentStatus, completed_pages, complete } = data;
        if (documentStatus === 'failed') {
            APP.UI.alertMessage('share.no_converting');
            APP.store.dispatch(removeShareItem(uuid, isRemote));
            return;
        }
        const document = getDocumentItemByUUID(APP.store.getState, uuid);
        if (document) {
            if (completed_pages.length >= 1) {
                APP.store.dispatch(updateShareItem(uuid, {
                    uuid,
                    page: resource_id,
                    count: completed_pages.length,
                    list: completed_pages,
                    complete: true,
                    isWhiteBoard: false,
                }));
            }
        }
    }
    /**
     * 문서 포커스
     * @param {string} mode
     * @param {object<{uuid, index}>} data
     */
    handlerFocusItem(mode, { video_uuid, uuid, index }) {
        if (mode === videoLayoutMode.vod) {
            APP.store.dispatch(setFocusShareItem(video_uuid, DEFAULT_INDEX, mode, isRemote));
        }
        else {
            APP.store.dispatch(setFocusShareItem(uuid, index, mode, isRemote));
        }
    }
    /**
     * 문서 캔버스
     * @param {object<{ uuid, index, key, value }}} data
     */
    handlerSetShareCanvas(data) {
        const { uuid, index, key, value } = data;
        APP.store.dispatch(setCanvasPoint({ uuid, index: Number(index), key, ...value }, isRemote));
    }
    /**
     * 문서 캔버스 지우기
     * @param {*} data
     */
    handlerDelShareCanvas(data) {
        const { uuid, index, key, isAll } = data;
        if (!isAll)
            APP.store.dispatch(deleteCanvaskey(uuid, Number(index), key, isRemote));
        else
            APP.store.dispatch(deleteCanvasIndex(uuid, Number(index), isRemote));
    }
    /**
     * 채팅
     */
    handlerSetMessage({ message, time }) {
        const { dispatch, getState } = APP.store;
        if (!isChatOpend(getState)) {
            dispatch(setIsChatRead(false));
            return;
        }
        if (getState()['features/base/sidebar'].hideChat)
            return;
        else {
            const data = JSON.parse(message);
            const local = getLocalMember(getState);
            const kstTimestamp = new Date(time).getTime();
            // 실시간 수신 키를 서버시각 기반으로 정규화 — 서버 조회(REST, 서버 저장시각 키) 경로와
            // 키 체계를 맞춰, 같은 메시지가 소스에 따라 다른 키(클라 송신시각 vs 서버시각)로
            // 이중 표시되는 것을 줄인다. (잔여 불일치는 리듀서의 근접 중복 억제가 커버)
            const canonical = { ...data, timestamp: kstTimestamp, uuid: `${kstTimestamp}_${data?.from}` };
            if (data?.from === local?.user_uuid) {
                // 발신 시점의 낙관적 항목(클라이언트 시각 키)을 서버 확정본으로 교체(삭제 후 삽입).
                // isEcho: 새 메시지가 아니라 기존 메시지의 키 교체 — 스크롤/배너 트리거 억제용.
                dispatch(updateMessage({ ...canonical, isMe: true, isEcho: true }, data?.uuid));
            }
            else {
                dispatch(addMessage(canonical, false));
            }
        }
    }
    handlerSetFile({ message }) {
        const { dispatch } = APP.store;
        const data = JSON.parse(message);
        if (data?.type === 'dualConnection') {
            dispatch(connectionDual(data));
            return;
        }
        // APP.store.dispatch(addShareFile(message, isRemote));
    }
    /**
     * (POLICY)
     * 현재 방 설정
     * @param {object} policy
     * @returns
     */
    updatePolicy({ policy }) {
        APP.store.dispatch(updateRoomPolicy(policy, isRemote));
    }
    /**
     * (POLICY)
     * 그리드 옵션 설정
     */
    setGridOption({ grid_count }) {
        APP.store.dispatch(updateGridOption(null, grid_count, isRemote));
    }
    handlerStartAttendances(data) {
        const { name, uuid, check_duration } = data;
        APP.store.dispatch(showStartAttendance({ name, uuid, check_duration }));
    }
}
const getMeetingIceServer = async () => {
    try {
        const meeting_id = getRoomOption(APP.store.getState).uuid;
        if (!meeting_id) {
            throw new Error('Meeting ID is not available');
        }
        const accessToken = getAccessToken(APP.store);
        if (!accessToken || accessToken === '') {
            throw new Error('Access token is not available');
        }
        const response = await fetch(`/api/meeting/v1/meetings/${meeting_id}/ice-servers`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data.result.ice_servers;
    }
    catch (error) {
        console.error('Error fetching ICE server:', error);
        // 여기서 에러를 처리하거나 상위 컴포넌트로 throw할 수 있습니다.
        return APP.config.ice_servers;
    }
};
export default new MateMessage();
